import { DateFilterRangeShortcut } from '@core/models/filter/date-filter-range-shorcut';

export interface IListFilterState {
    start?: string;
    end?: string;
    schedules?: string[];
    locations?: string[];
    users?: string[];
    name?: string;
    rangeShortcut?: DateFilterRangeShortcut;
}

export function initialListFilterState(): IListFilterState {
    return {};
};